import {
    ChangeEvent,
    Component,
    DataSourceMode,
    DropdownItem,
    EditRowDecorator,
    TableRow,
    TableRowDisplayEvent,
    Textbox
} from "@mcleod/components";
import { AutogenLayoutPbwLoadboardServices } from "./autogen/AutogenLayoutPbwLoadboardServices";
import {StringUtil} from "@mcleod/core";

const TRUCKSTOP_REST_TYPE = 'R';
const disabledTooltip = "Disabled for Truckstop REST service type";

export class PbwLoadboardServices extends AutogenLayoutPbwLoadboardServices {

    override onLoad() {
        this.tablePbwLoadboardServices.onEditLayoutLoaded = this._controlFileLoaded;
    }

    private _controlFileLoaded(rowDecorator: EditRowDecorator, tableRow: TableRow): void {
        rowDecorator.labelTitle.text = `Load Board Service`;
        if (rowDecorator.btnDelete) {
            rowDecorator.btnDelete.visible = false;
        }
    }

    /** This is an event handler for the onRowDisplay event of tablePbwLoadboardServices.  */
    tablePbwLoadboardServicesOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const textboxFileType = tableRow.findComponentById("textboxServiceType") as Textbox;
        const textboxAccountId = tableRow.findComponentById("textboxAccountId") as Textbox;
        const textboxPassword = tableRow.findComponentById("textboxPassword") as Textbox;
        this.enableCredentialComps(tableRow, [textboxAccountId, textboxPassword]);
    }

    enableCredentialComps(tableRow: TableRow, components: Component[]) {
        const isEnableUserAndPassword =
            TRUCKSTOP_REST_TYPE != tableRow.data?.get("service_type");
        components?.forEach((comp) => {
            comp.enabled = isEnableUserAndPassword;
            if (!isEnableUserAndPassword) tableRow.data?.set(comp.field, null);
            comp.disabledTooltip = disabledTooltip;
        });
    }

    textboxServiceTypeOnChange(event: ChangeEvent) {
        if (!event.userInitiatedChange || event.oldValue === event.newValue) {
            return;
        }
        const tableRow = TableRow.getContainingTableRow(event.target as Component);
        const serviceType: string | undefined = event?.newValue;
        const isTruckstopRest = !StringUtil.isEmptyString(serviceType) && StringUtil.equalsIgnoreCase("TRUCKSTOP", serviceType);
        this.toggleTextboxState(tableRow, "textboxAccountId", !isTruckstopRest);
        this.toggleTextboxState(tableRow, "textboxPassword", !isTruckstopRest);
    }

    private toggleTextboxState(tableRow: TableRow, textboxId: string, isEnabled: boolean) {
        const textbox = tableRow.findComponentById(textboxId) as Textbox;
        textbox.enabled = isEnabled;
        textbox.disabledTooltip = isEnabled ? null : disabledTooltip;
    }

}

